import * as ambassadorWixEmailsubscriptionsV1Emailsubscription from './emailsubscriptions-v1-emailsubscription-email-subscriptions.http.js';
import * as ambassadorWixEmailsubscriptionsV1EmailsubscriptionTypes from './emailsubscriptions-v1-emailsubscription-email-subscriptions.types.js';
import * as ambassadorWixEmailsubscriptionsV1EmailsubscriptionUniversalTypes from './emailsubscriptions-v1-emailsubscription-email-subscriptions.universal.js';

export type __PublicMethodMetaInfo<
  K = string,
  M = unknown,
  T = unknown,
  S = unknown,
  Q = unknown,
  R = unknown
> = {
  getUrl: (context: any) => string;
  httpMethod: K;
  path: string;
  pathParams: M;
  __requestType: T;
  __originalRequestType: S;
  __responseType: Q;
  __originalResponseType: R;
};

export function getEmailSubscription(): __PublicMethodMetaInfo<
  'GET',
  { id: string },
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionUniversalTypes.GetEmailSubscriptionRequest,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionTypes.GetEmailSubscriptionRequest,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionUniversalTypes.GetEmailSubscriptionResponse,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionTypes.GetEmailSubscriptionResponse
> {
  const payload = { id: ':id' } as any;

  const getRequestOptions =
    ambassadorWixEmailsubscriptionsV1Emailsubscription.getEmailSubscription(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'GET',
    path: '/v1/email-subscriptions/{id}',
    pathParams: { id: 'id' },
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function queryEmailSubscriptions(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionUniversalTypes.QueryEmailSubscriptionsRequest,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionTypes.QueryEmailSubscriptionsRequest,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionUniversalTypes.QueryEmailSubscriptionsResponse,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionTypes.QueryEmailSubscriptionsResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailsubscriptionsV1Emailsubscription.queryEmailSubscriptions(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/email-subscriptions/query',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function upsertEmailSubscription(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionUniversalTypes.UpsertEmailSubscriptionRequest,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionTypes.UpsertEmailSubscriptionRequest,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionUniversalTypes.UpsertEmailSubscriptionResponse,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionTypes.UpsertEmailSubscriptionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailsubscriptionsV1Emailsubscription.upsertEmailSubscription(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/email-subscriptions',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function bulkUpsertEmailSubscription(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionUniversalTypes.BulkUpsertEmailSubscriptionRequest,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionTypes.BulkUpsertEmailSubscriptionRequest,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionUniversalTypes.BulkUpsertEmailSubscriptionResponse,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionTypes.BulkUpsertEmailSubscriptionResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailsubscriptionsV1Emailsubscription.bulkUpsertEmailSubscription(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/email-subscriptions/bulk',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export function generateUnsubscribeLink(): __PublicMethodMetaInfo<
  'POST',
  {},
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionUniversalTypes.GenerateUnsubscribeLinkRequest,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionTypes.GenerateUnsubscribeLinkRequest,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionUniversalTypes.GenerateUnsubscribeLinkResponse,
  ambassadorWixEmailsubscriptionsV1EmailsubscriptionTypes.GenerateUnsubscribeLinkResponse
> {
  const payload = {} as any;

  const getRequestOptions =
    ambassadorWixEmailsubscriptionsV1Emailsubscription.generateUnsubscribeLink(
      payload
    );

  const getUrl = (context: any): string => {
    const { url } = getRequestOptions(context);
    return url!;
  };

  return {
    getUrl,
    httpMethod: 'POST',
    path: '/v1/email-subscriptions/unsubscribe-link',
    pathParams: {},
    __requestType: null as any,
    __originalRequestType: null as any,
    __responseType: null as any,
    __originalResponseType: null as any,
  };
}

export {
  EmailSubscription as EmailSubscriptionOriginal,
  SubscriptionEnumStatus as SubscriptionEnumStatusOriginal,
  SubscriptionEnumStatusWithLiterals as SubscriptionEnumStatusWithLiteralsOriginal,
  Status as StatusOriginal,
  StatusWithLiterals as StatusWithLiteralsOriginal,
  EmailSubscriptionChanged as EmailSubscriptionChangedOriginal,
  GetEmailSubscriptionRequest as GetEmailSubscriptionRequestOriginal,
  GetEmailSubscriptionResponse as GetEmailSubscriptionResponseOriginal,
  UpdateEmailSubscriptionRequest as UpdateEmailSubscriptionRequestOriginal,
  UpdateEmailSubscriptionResponse as UpdateEmailSubscriptionResponseOriginal,
  QueryEmailSubscriptionsRequest as QueryEmailSubscriptionsRequestOriginal,
  Paging as PagingOriginal,
  QueryEmailSubscriptionsResponse as QueryEmailSubscriptionsResponseOriginal,
  PagingMetadata as PagingMetadataOriginal,
  UpsertEmailSubscriptionRequest as UpsertEmailSubscriptionRequestOriginal,
  UpsertEmailSubscriptionResponse as UpsertEmailSubscriptionResponseOriginal,
  BulkUpsertEmailSubscriptionRequest as BulkUpsertEmailSubscriptionRequestOriginal,
  BulkUpsertEmailSubscriptionResponse as BulkUpsertEmailSubscriptionResponseOriginal,
  BulkUpsertEmailSubscriptionResult as BulkUpsertEmailSubscriptionResultOriginal,
  Error as ErrorOriginal,
  Metadata as MetadataOriginal,
  GenerateUnsubscribeLinkRequest as GenerateUnsubscribeLinkRequestOriginal,
  GenerateUnsubscribeLinkResponse as GenerateUnsubscribeLinkResponseOriginal,
  RenderUnsubscribePageRequest as RenderUnsubscribePageRequestOriginal,
  RawHttpResponse as RawHttpResponseOriginal,
  HeadersEntry as HeadersEntryOriginal,
  ConfirmUnsubscribeActionRequest as ConfirmUnsubscribeActionRequestOriginal,
  Empty as EmptyOriginal,
  DomainEvent as DomainEventOriginal,
  DomainEventBodyOneOf as DomainEventBodyOneOfOriginal,
  EntityCreatedEvent as EntityCreatedEventOriginal,
  RestoreInfo as RestoreInfoOriginal,
  EntityUpdatedEvent as EntityUpdatedEventOriginal,
  EntityDeletedEvent as EntityDeletedEventOriginal,
  ActionEvent as ActionEventOriginal,
  MessageEnvelope as MessageEnvelopeOriginal,
  IdentificationData as IdentificationDataOriginal,
  IdentificationDataIdOneOf as IdentificationDataIdOneOfOriginal,
  WebhookIdentityType as WebhookIdentityTypeOriginal,
  WebhookIdentityTypeWithLiterals as WebhookIdentityTypeWithLiteralsOriginal,
  AccountInfo as AccountInfoOriginal,
  V1RenderUnsubscribePageRequest as V1RenderUnsubscribePageRequestOriginal,
  V1ConfirmUnsubscribeActionRequest as V1ConfirmUnsubscribeActionRequestOriginal,
} from './emailsubscriptions-v1-emailsubscription-email-subscriptions.types.js';
